import type { TradeStatisticsFilters } from "../../../types/trade";
import type { TradeFilterSelectOption } from "@/components/trade-filter-selects";

/** Same presets as `/trades/statistics?timeframe=` and dashboard summary cards. */
export type ExecutingAccountStatsTimeframe = NonNullable<
  TradeStatisticsFilters["timeframe"]
>;

export const EXECUTING_ACCOUNT_SUMMARY_PRESETS: ReadonlyArray<{
  id: ExecutingAccountStatsTimeframe;
  label: string;
}> = [
  { id: "today", label: "Today" },
  { id: "7-days", label: "7 days" },
  { id: "14-days", label: "14 days" },
  { id: "30-days", label: "30 days" },
  { id: "all-time", label: "All time" },
];

export const EXECUTING_ACCOUNT_SUMMARY_PRESET_OPTIONS: TradeFilterSelectOption[] =
  EXECUTING_ACCOUNT_SUMMARY_PRESETS.map((option) => ({
    value: option.id,
    label: option.label,
  }));

export function formatExecutingAccountWinRatePercent(
  winRate: number | null | undefined
): string {
  if (winRate == null || !Number.isFinite(winRate)) return "—";
  const pct = winRate >= 0 && winRate <= 1 ? winRate * 100 : winRate;
  return `${pct.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
}
